import React, { useState, useEffect } from 'react';

const ManageImages = () => {
  const [images, setImages] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // ดึงข้อมูลจาก Cloudflare Worker
    const fetchImages = async () => {
      const response = await fetch('https://r2-public.wordbalance931.workers.dev'); // URL ของ Worker ที่คุณสร้าง
      const data = await response.json();
      setImages(data.images);  // ใช้ data.images แทน data ทั้งหมด
      setIsLoading(false);
    };
    fetchImages();
  }, []);  // รันครั้งเดียวเมื่อคอมโพเนนต์โหลด

  return (
    <div className="manage-images-container">
      <h2 className="title">การจัดการรูปทั้งหมด</h2>
      {isLoading ? (
        <div className="loading">กำลังโหลด...</div>
      ) : (
        <table className="image-table">
          <thead>
            <tr>
              <th>ชื่อรูป</th>
              <th>จำนวนครั้งที่ใช้</th>
              <th>ภาพ</th> {/* เพิ่มคอลัมน์สำหรับการแสดงภาพ */}
            </tr>
          </thead>
          <tbody>
            {images.length > 0 ? (
              images.map((image, index) => (
                <tr key={index}>
                  <td>{image.name}</td>
                  <td>{image.usageCount}</td>
                  <td>
                    {/* แสดงภาพ */}
                    <img
                      src={`https://r2-public.wordbalance931.workers.dev/${image.name}`} 
                      alt={image.name} 
                      width="100" 
                      height="auto"
                    />
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3" style={{ textAlign: 'center' }}>
                  ไม่มีข้อมูลรูปภาพ
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default ManageImages;
